export enum MapLayer {
  LEVEL_OF_SERVICE = 'LEVEL_OF_SERVICE',
  PARKING = 'PARKING',
  TRAFFIC_REPORT = 'TRAFFIC_REPORT',
}
